import { Box, VStack } from '@terra/ui-styled-system';
import { Text } from '../../../../../components/styled/text';
import { MarkdownPreview } from '../../../../markdown-preview';
import { isMarkdown } from '../content-detection';

type PlainTextRendererProps = {
  content: string;
  maxHeight?: string;
  showLabel?: boolean;
};

export function PlainTextRenderer({
  content,
  maxHeight,
  showLabel = false,
}: PlainTextRendererProps) {
  const looksLikeMarkdown = isMarkdown(content);

  const renderContent = () => {
    if (looksLikeMarkdown) {
      return <MarkdownPreview source={content} fontSize={12} compact />;
    } else {
      return (
        <Text
          fontSize="xs"
          fontFamily="mono"
          color="fg.subtle"
          whiteSpace="pre-wrap"
        >
          {content}
        </Text>
      );
    }
  };

  return (
    <VStack alignItems="start" gap={2} width="100%">
      {showLabel && (
        <Text fontSize="xs" fontWeight="medium" color="fg.default">
          {'Text Output'}
        </Text>
      )}
      <Box
        bg="bg.canvas"
        p={2}
        borderRadius="sm"
        borderWidth="1px"
        borderColor="border.subtle"
        width="100%"
        maxHeight={maxHeight}
        overflow={maxHeight ? 'auto' : undefined}
        position="relative"
      >
        {renderContent()}
      </Box>
    </VStack>
  );
}
